import React from "react";
import Banner from "../components/Banner";
import CarouselHero from "../components/Carousel";
import ChocolateBanner from "../components/ChocolateBanner";
import Footer from "../components/Footer";
import KesarBanner from "../components/KesarBanner";
import Menu from "../components/Menu";
import NavbarComponent from "../components/Navbar";
import Products from "../components/Products";

const Homepage = () => {
  return (
    <div>
      <Banner />
      <NavbarComponent />
      <CarouselHero />
      <Menu />
      <ChocolateBanner />
      <Products />
      <KesarBanner />
      <Footer />
    </div>
  );
};

export default Homepage;
